import { defineStyle } from '@chakra-ui/react';

import borders from '@/styles/themes/brand/borders';

const style = defineStyle({
  root: {
    maxW: '950px',
    '.dashboardHomeSkeletonText': {
      noOfLines: 1,
      w: '100%',
      maxW: '100%',
    },
    '.dashboardHomeSkeletonText1': {
      noOfLines: 1,
      w: '400px',
      maxW: '100%',
    },
    '.dashboardHomeSkeletonText2': {
      mt: '5px',
      noOfLines: 1,
      w: '100%',
      maxW: '100%',
    },
    '.dashboardHomeSkeletonText3': {
      noOfLines: 2,
      w: '70%',
      maxW: '100%',
      mb: '32px',
    },
    '.dashboardHomeSkeletonText4': {
      noOfLines: 2,
      w: '400px',
      maxW: '100%',
      mb: '32px',
    },
    '.dashboardHomeSkeletonText5': {
      noOfLines: 1,
      w: '400px',
      maxW: '100%',
      mb: '32px',
    },
    '.dashboardHomeSkeletonText6': {
      noOfLines: 2,
      mb: '48px',
    },
    '.dashboardHomeSkeletonStack0': {
      mt: '5px',
    },
    '.dashboardHomeSkeletonStack1': {
      mt: '20px',
      backgroundColor: '#fff',
      borderRadius: borders.normal,
    },
    '.dashboardHomeSkeletonStack2': {
      px: '48px',
      pt: '32px',
    },
    '.dashboardHomeSkeletonStack3': {
      mt: '20px',
      backgroundColor: '#fff',
      borderRadius: borders.normal,
    },
    '.dashboardHomeSkeletonCircle': {
      ml: 'auto',
      w: '150px',
      h: '50px',
    },
    '.dashboardHomeSkeleton': {
      height: '315px',
    },
    '.dashboardHomeSkeletonStack4': {
      px: '48px',
      pt: '32px',
      pb: '48px',
    },
  },
});

export default style;
